<div class="app-layout" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Sidebar Navigation -->
  <app-sidebar
    [collapsed]="sidebarCollapsed"
    (toggleSidebar)="toggleSidebar()"
  ></app-sidebar>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Top Bar -->
    <app-topbar (toggleSidebar)="toggleSidebar()"></app-topbar>
    <!-- Page Content -->
    <div class="content-wrapper px-4 px-lg-5 py-5">
      <router-outlet></router-outlet>
    </div>

    <!-- Footer -->
    <footer class="app-footer px-4 px-lg-5">
      <div class="d-flex flex-column flex-md-row justify-content-md-between justify-content-center align-items-center gap-2">
        <div class="d-flex align-items-center gap-2">
          <img src="assets/images/logo-icon.png" alt="ADN Logo" class="footer-logo" />
          <span class="footer-text fw-normal">Proudly Made in the USA</span>
        </div>
        <!-- Right-hand meta cluster, stacked so Technical Support sits on
             its own line above the legal links + version. -->
        <div class="footer-meta d-flex flex-column align-items-center align-items-md-end gap-1 text-muted small">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-telephone"></i>
            <span>Technical Support:</span>
            <a [href]="'tel:' + technicalSupportPhone" class="text-muted text-decoration-none">
              {{ formattedSupportPhone }}
            </a>
          </div>
          <!-- Legal links (moved from the sidebar) + version. `noreferrer`
               in addition to `noopener` so the outbound click doesn't leak
               the in-app URL to the external policy host via Referer. -->
          <div class="footer-legal d-flex align-items-center gap-2">
            <a [href]="legalUrls.privacyPolicy" target="_blank" rel="noopener noreferrer" class="text-muted text-decoration-none">Privacy Policy</a>
            <span class="footer-legal-sep">·</span>
            <a [href]="legalUrls.termsOfUse" target="_blank" rel="noopener noreferrer" class="text-muted text-decoration-none">Terms of Use</a>
            <span class="footer-legal-sep">·</span>
            <span class="text-nowrap">Version {{ appVersion }}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>

  <!-- Toast Notifications -->
  <app-toast-container></app-toast-container>
</div>
